<template>
    <div class="create-box">
        <div class="top-box">
            <el-radio-group style="margin-top: 0.4rem;" v-model="modelVal" @input="search">
                        <el-radio v-for="(item,index) in optionArr" :label="item.value" :key="index">{{ item.label }}</el-radio>
            </el-radio-group>
            <div class="input-box">
                <div style="display: flex;align-items: center;" v-if="activeName=='resource'">
                    <div style="margin-right: 1rem;">类型</div>
                    <el-select v-model="type" style="width: 14rem;" @change="search" placeholder="请选择类型">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="card-content animate__animated animate__fadeIn"  v-show="tableData.length>0">
            <div class="card-box" v-for="(item,index) in tableData" @click="toDetail(item)" :key="index">
                <div class="no-start-label" v-if="activeName=='course'" :style="`background-color:${filterStatus(item.courseStatus)};`">{{ item.courseStatus }}</div>
                <div class="label-box" v-else-if="activeName=='resource'" :style="`background-color: ${filterBgc(item.type)};`">{{
                    item.type == 'ppt' ?'课件':item.type }}</div>
            <img class="img-style" :src="getImgSrc(item)" alt="">
            <div class="bottom-box">
                <p>{{ item.courseName }}</p>
                <div>
                    <div style="display: flex;">
                        <div>收藏于：</div>
                        <div>{{ item.createTime }}</div>
                    </div>
                    <el-dropdown>
                    <span class="el-dropdown-link">
                        <i class="iconfont icon-icon_665" @click.stop></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="cancelCollection(item)">取消收藏</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        </div>
        <no-data style="height: calc(100vh - 45rem);" v-show="tableData.length==0"></no-data>
        <div class="page-box" v-if="tableData.length>0">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.current"
                :page-sizes="[8, 16, 32]"
                :page-size="pages.size"
                :pager-count="5"
                :layout="$store.state.media.layout"
                :total="pages.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { PageList } from '@/api/course';
import { PageQueryMyCollectList } from '@/api/paper';
import { PageMyCollectList }  from '@/api/resourceMag';
import {PageQueryCollectList} from '@/api/software';
import { AddOptRecord } from '@/api/operation';
import { OPERATIONTYPE } from '@/utils/utils';
    export default {
        props:['classifyCode','name','activeName'],
        data(){
            return {
                /**列表数据 */
                tableData:[],
                modelVal:'',
                pages:{
                    current:1,
                    size:8,
                    total:0,
                },
                /**类型 */
                type:'',
                optionArr:[
                {
                    label:'课程',
                    value:'course'
                },
                {
                    label:'资源',
                    value:'resource'
                },
                {
                    label:'仿真软件',
                    value:'software'
                },
                {
                    label:'试卷',
                    value:'paper'
                },
                ],
                options:[
                {
                    label:'全部',
                    value:''
                },
                {
                    label:'PPT',
                    value:'ppt'
                },
                {
                    label:'动画',
                    value:'动画'
                },
                {
                    label:'模型',
                    value:'模型'
                },
                {
                    label:'文档',
                    value:'文档'
                },
                {
                    label:'视频',
                    value:'视频'
                },
                {
                    label:'图片',
                    value:'图片'
                }
                ]
            }
        },
        methods:{
            handleSizeChange(e){
                this.pages.size=e;
                this.pages.current=1;
                this.queryTableList();
            },
            handleCurrentChange(e){
                this.pages.current=e;
                this.queryTableList();
            },
            /**过滤封面图 */
            getImgSrc(item){
                var obj={
                    'resource':item.coverImageUrl?this.$severUrl(item.coverImageUrl):this.$filterResDefault(item.type),
                    'software':item.coverImageUrl?this.$severUrl(item.coverImageUrl):this.$filterResDefault('仿真软件'),
                    'course':item.coverImageUrl?this.$severUrl(item.coverImageUrl):this.$filterResDefault(item.classifyCode),
                    'paper':this.$filterResDefault('试卷')
                }
                return obj[this.activeName];
            },
        filterStatus(status){
            var obj={
                '未发布':'#EAD656',
                '审核中':'#D5698A',
                '审核不通过':'#f56c6c',
                '未开始':'#86B9FF',
                "已结束":'#8F98A9'
            }
            return obj[status]||'#67c23a';
        },
        filterBgc(type) {
            var obj = {
                '仿真软件': '#387DFF',
                'ppt': '#FE7C4B',
                '动画': '#D5698A',
                '模型': '#86B9FF',
                '视频': '#555CF7',
                '图片': '#24B89A',
                '试卷': '#EAD656',
                '文档': '#8F98A9'
            }
            return obj[type];
        },
            /**获取我收藏的课程 */
            userCollections(){
                let params={
                    "classifyCode":this.classifyCode,
                    "courseName": this.name,
                    "current": this.pages.current,
                    "queryType": 2,
                    "size": this.pages.size
                }
                PageList(params).then(res=>{
                    if(res.code==200){
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            toDetail(item){
                this.$store.commit('backend/changePath',this.$route.path);
                var obj={
                    course:{
                        path:'/course/courseDetail',
                        query:{
                            id:item.id,
                        }
                    },
                    resource:{
                        path:'/personCenter/resourceDetail',
                        query:{id:item.id,type:item.type}
                    },
                    software:{
                        path:'/personCenter/detail',
                        query:{id:item.id}
                    },
                    paper:{
                        path:'/personCenter/paperDetail',
                        query:{
                            id:item.id,
                            testPaperSource:'course_study'
                        }
                    }
                }
                var data=obj[this.activeName];
                this.$router.push({
                    path:data.path,
                    query:data.query
                });
            },
            /**获取我收藏的资源 */
            pageMyCollectList(){
                var params={
                "classifyCode": this.classifyCode,
                "current":this.pages.current,
                "resourceName": this.name,
                "size": this.pages.size,
                "type": this.type
                };
                PageMyCollectList(params).then(res=>{
                    if(res.code==200){
                        res.data.records=res.data.records.map(item=>{
                            return {
                                courseName:item.resourceName,
                                createTime:item.createTime,
                                coverImageUrl:item.coverPath,
                                id:item.id,
                                type:item.type
                            }
                        });
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            /**获取我收藏的试卷 */
            pageQueryMyCollectList(){
                var params={
                "current": this.pages.current,
                "size": this.pages.size,
                "testPaperName": this.name
                }
                PageQueryMyCollectList(params).then(res=>{
                    if(res.code==200){
                        res.data.records=res.data.records.map(item=>{
                            return {
                                courseName:item.testPaperName,
                                createTime:item.createTime,
                                id:item.id
                            }
                        });
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            /**获取我收藏的仿真软件 */
            pageQueryCollectList(){
                var params={
                "classifyCode": this.classifyCode,
                "current": this.pages.current,
                "resourceName": this.name,
                "size": this.pages.size
                }
                PageQueryCollectList(params).then(res=>{
                    if(res.code==200){
                        res.data.records=res.data.records.map(item=>{
                            return {
                                courseName:item.softwareName,
                                createTime:item.createTime,
                                coverImageUrl:item.softwareCover,
                                id:item.id
                            }
                        });
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
            })
            },
            queryTableList(){
                this.tableData=[];
                this.$nextTick(()=>{
                    var obj={
                        course:this.userCollections,
                        resource:this.pageMyCollectList,
                        software:this.pageQueryCollectList,
                        paper:this.pageQueryMyCollectList
                    }
                    obj[this.activeName]();
                })
            },
            search(){
                this.pages.current=1;
                this.queryTableList();
            },
            /**取消收藏 */
            cancelCollection(item){
                this.$confirm('是否确认取消收藏?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                var params={
                "businessId": item.id,
                "businessType": this.activeName,
                "optType": OPERATIONTYPE[1]
                }
                AddOptRecord(params).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "取消收藏成功",
                            type: "success",
                        });
                        this.userCollections();
                    }
                })
              }).catch(() => {
                console.log('no');
              });
            },
        },
        watch:{
            modelVal:{
                handler(value){
                    this.$emit('changeModel',value);
                },
            }
        },
        mounted(){
            console.log(this.$route,'.....')
            this.queryTableList();
            if(!this.modelVal){
                this.modelVal=this.activeName;
            }
        },
        beforeDestroy(){
        }
    }
</script>

<style lang="less" scoped>
.create-box{
    height: 100%;
}
.top-box{
    display: flex;
    justify-content: space-between;
    height: 4rem;
    align-items: center;
}
.btn-box{
    width: 16rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #334681;
    cursor: pointer;
    i{
        color: var(--blue);
        margin-right: 3px;
    }
}
.input-box{
    display: flex;
    align-items: center;
    color: #334681;
    &> :nth-child(1){
        margin-right: 1rem;
        cursor: pointer;
    }
}
.card-content{
    margin-top: 1rem;
    padding-top: 1rem;
    height: calc(100% - 7rem);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    column-gap: 2rem;
    row-gap: 4rem;
    &> :nth-child(n){
        cursor: pointer;
    }
}
.card-box:hover{
    transform: translateY(-1rem);
}
.card-box{
    border: 1px solid #ebeef5;
    display: inline-block;
    width: calc((100% - 6rem) / 4);
    min-width: 28rem;
    transition: all 0.3s;
    position: relative;
    background-color: #ffffff;
    .no-start-label{
        width: 48px;
        height: 24px;
        color: #ffffff;
        border-radius: 0px 0px 10px 0px;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.img-style{
    width: 100%;
    aspect-ratio: var(--aspectRatio);
    object-fit: cover;
}
.bottom-box{
    padding: 1.5rem;
    &> :nth-child(1){
        color: #334681;
        font-weight: 700;
        font-size: 16px;
    }
   &> :nth-child(2){
    color: #8590B3;
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
    i{
        font-weight: 700;
        cursor: pointer;
        margin-left: 1rem;
    }
   }
}
.label-box {
            position: absolute;
            right: 0;
            top: 0;
            width: 6rem;
            height: 2.5rem;
            border-radius: 0px 0px 0px 24px;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
        }
.page-box{
    padding: 3rem 0;
    display: flex;
    justify-content: center;
}
@media screen and (max-width:750px){
    .card-box{
        width: 100% !important;
    }
}
</style>